import React from 'react';

const PageNotFound = () => {
  return (
    <p className="page-not-found" style={{ marginTop: '6rem' }}>
      Page not found
    </p>
  );
};

export default PageNotFound;
